import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mantine/core";

import MainNavigation from "../components/navigation/MainNavigation";
import Footer from "../components/common/Footer/Footer";
import LocationCompletionModal from "../components/common/LocationCompletionModal";

function RootLayout() {
  const loggedInUser = useSelector((state) => state.auth.user);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <MainNavigation />
      {loggedInUser && <LocationCompletionModal />}
      <Box component="main" style={{ flex: 1, padding: 0 }}>
        <Outlet />
      </Box>

      <Footer />
    </Box>
  );
}

export default RootLayout;
